import React from 'react';
import { Linking, Pressable, StyleSheet, Text, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { PRIVACY_POLICY_LINK_LABEL, REQUEST_ACCOUNT_DELETION_LINK_LABEL, } from '../config/storeMessaging';
import { theme } from '../theme';
/**
 * Web footer: discoverable Privacy + account deletion (usual industry bar for D4).
 * Native keeps `Footer.tsx` (deploy stamp only).
 * Stacked with padded hit targets — narrow side panel wraps a row into a cramped stack.
 */
const Footer = () => {
    const navigation = useNavigation();
    const buildDate = new Date(BUILD_DATE);
    const formattedDate = new Intl.DateTimeFormat('en-US', {
        dateStyle: 'medium',
        timeStyle: 'short',
    }).format(buildDate);
    const openPrivacy = () => {
        const origin = typeof window !== 'undefined' && window.location?.origin
            ? window.location.origin
            : '';
        if (origin) {
            Linking.openURL(`${origin}/privacy.html`);
            return;
        }
        Linking.openURL('/privacy.html');
    };
    return (<View style={styles.container}>
      <View style={styles.links}>
        <Pressable style={styles.linkHit} onPress={openPrivacy} accessibilityRole="link" accessibilityLabel={PRIVACY_POLICY_LINK_LABEL}>
          <Text style={styles.link}>{PRIVACY_POLICY_LINK_LABEL}</Text>
        </Pressable>
        <Pressable style={styles.linkHit} onPress={() => navigation.navigate('RequestAccountDeletion')} accessibilityRole="link" accessibilityLabel={REQUEST_ACCOUNT_DELETION_LINK_LABEL}>
          <Text style={styles.link}>{REQUEST_ACCOUNT_DELETION_LINK_LABEL}</Text>
        </Pressable>
      </View>
      <Text style={styles.text}>Deployed on {formattedDate}</Text>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        paddingTop: 12,
        paddingBottom: 8,
    },
    links: {
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 10,
        gap: 4,
    },
    linkHit: {
        paddingVertical: 10,
        paddingHorizontal: 12,
        minHeight: 40,
        justifyContent: 'center',
    },
    link: {
        fontSize: 13,
        color: theme.colors.surfaceElevated,
        textDecorationLine: 'underline',
        fontWeight: '600',
        textAlign: 'center',
    },
    text: {
        fontSize: 10,
        color: theme.colors.textSubtleOnInverse,
        fontStyle: 'italic',
        textAlign: 'center',
    },
});
export default Footer;
